import AddIcon from '@mui/icons-material/Add';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import {
  Chip,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { checkAccessAdministrator } from '../../helpers/utils/RoleManager';
import ManageUser from './AdminUser.jsx';

const Element = ({ element, setSelectedElement, setDisplayContent }) => {
  const profile = useSelector((state) => state?.login?.profile);

  const blackList = [
    '_id',
    '__v',
    'picture',
    'createdAt',
    'updatedAt',
    'ticketType',
    'permission',
    'nbTicket',
    'nbTask',
    'sipPassword',
    'sipExtension',
  ];

  const renderCellValue = (value) => {
    if (value === true) {
      return <CheckCircleIcon color="success" />;
    }
    if (value === false) {
      return <CancelIcon color="error" />;
    }
    if (value?.name) {
      return <Chip label={value.name} size="small" />;
    }
    if (value?.$numberDecimal) {
      return (
        <Chip label={value.$numberDecimal} size="small" variant="outlined" />
      );
    }
    if (Array.isArray(value)) {
      return (
        <div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
          {value
            .map((item) => item?.name)
            .filter(Boolean)
            .map((name, index) => (
              <Chip key={index} label={name} size="small" variant="outlined" />
            ))}
        </div>
      );
    }
    return value;
  };

  const handleChangeElement = () => {
    setSelectedElement(element);
    setDisplayContent('ManageElement');
  };

  const filteredEntries = Object.entries(element).filter(
    ([key]) => !blackList.includes(key)
  );

  return (
    <TableRow>
      {filteredEntries.map(([key, value]) => (
        <TableCell key={key}>{renderCellValue(value)}</TableCell>
      ))}
      <TableCell align="right">
        <IconButton
          onClick={handleChangeElement}
          disabled={!checkAccessAdministrator(profile)}
        >
          <SettingsIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

const ElementList = ({
  elements,
  setSelectedElement,
  setDisplayContent,
  cells,
}) => {
  const handleCreateElement = () => {
    setSelectedElement(null);
    setDisplayContent('ManageElement');
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {cells?.map((cell) => (
              <TableCell key={cell}>{cell}</TableCell>
            ))}
            <TableCell align="right">
              <IconButton onClick={handleCreateElement}>
                <AddIcon />
              </IconButton>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {elements?.map((element) => (
            <Element
              key={element?._id}
              element={element}
              setSelectedElement={setSelectedElement}
              setDisplayContent={setDisplayContent}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const AdminPage = ({ isDeleteAllowed, elements, apiPath, cells }) => {
  const [selectedElement, setSelectedElement] = useState(null);
  const [displayContent, setDisplayContent] = useState('ElementList');

  useEffect(() => {
    setDisplayContent('ElementList');
  }, [apiPath]);

  return (
    <>
      {displayContent === 'ElementList' ? (
        <ElementList
          elements={elements}
          setSelectedElement={setSelectedElement}
          setDisplayContent={setDisplayContent}
          cells={cells}
        />
      ) : null}
      {displayContent === 'ManageElement' ? (
        apiPath === 'users' ? (
          <ManageUser
            user={selectedElement}
            setSelectedUser={setSelectedElement}
            setDisplayContent={setDisplayContent}
            isDeleteAllowed={isDeleteAllowed}
          />
        ) : null
      ) : null}
    </>
  );
};

export default AdminPage;
